import { render, staticRenderFns } from "./AddResellerPaymentComponent.vue?vue&type=template&id=82963046&"
import script from "./AddResellerPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./AddResellerPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports